import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a single bed (0.9 x 2.0, length along Z, headboard at -Z),
// same styling family as bed-double, one pillow.
const OAK = "#c8975a";
const WALNUT = "#7a5a3a";
const DUVET = "#f2efe8";
const BLANKET = "#8a9aa8";
const PILLOW = "#e8e4dc";

export const bedSingle = defineModel({
  id: "bed-single",
  batchId: "modern",
  name: "Bed (single)",
  tags: ["modern", "interior", "furniture", "bedroom", "bed"],
  summary: "A single bed with an oak frame, white duvet and one pillow.",
  tiles: { w: 1, h: 2 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // legs
      { geometry: new THREE.BoxGeometry(0.08, 0.12, 0.08), color: WALNUT, position: [-0.37, 0.06, -0.92] },
      { geometry: new THREE.BoxGeometry(0.08, 0.12, 0.08), color: WALNUT, position: [0.37, 0.06, -0.92] },
      { geometry: new THREE.BoxGeometry(0.08, 0.12, 0.08), color: WALNUT, position: [-0.37, 0.06, 0.92] },
      { geometry: new THREE.BoxGeometry(0.08, 0.12, 0.08), color: WALNUT, position: [0.37, 0.06, 0.92] },
      // frame
      { geometry: new THREE.BoxGeometry(0.9, 0.22, 2.0), color: OAK, position: [0, 0.23, 0] },
      // headboard at -Z
      { geometry: new THREE.BoxGeometry(0.9, 0.75, 0.08), color: OAK, position: [0, 0.68, -0.96] },
      // duvet slab
      { geometry: new THREE.BoxGeometry(0.8, 0.18, 1.84), color: DUVET, position: [0, 0.43, 0.02] },
      // folded blanket strip at the foot
      { geometry: new THREE.BoxGeometry(0.82, 0.07, 0.5), color: BLANKET, position: [0, 0.555, 0.62] },
      // pillow
      { geometry: new THREE.BoxGeometry(0.55, 0.12, 0.35), color: PILLOW, position: [0, 0.58, -0.7], rotation: [-0.15, 0, 0] },
    ];
  },
  animations: [],
});
